import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Strings } from "../../shared/tools/Strings";
import { BrillantField, BrillantsDto } from "cilor-db-api-shared";

@Injectable({
  providedIn: "root"
})
export class BrillantsService {
  public pageIndex: number;
  public pageSize: number;
  public sortPath: string;

  public data: BrillantsDto | null;
  public loading: boolean;
  public error: string | null;
  public filter: string;

  constructor(
    public readonly httpClient: HttpClient,
  ) {
    this.pageIndex = 0;
    this.pageSize = 10;
    this.sortPath = BrillantField.groesse;
    this.data = null;
    this.loading = false;
    this.error = null;
    this.filter = "";
  }

  public async loadBrillants(): Promise<void> {
    try {
      this.loading = true;
      this.error = null;
      const result = await this.httpClient.get<BrillantsDto>("/api/brillants",
        {
          params: {
            page: this.pageIndex.toString(),
            pageSize: this.pageSize.toString(),
            sortPath: this.sortPath,
            sortDirection: "asc",
            filter: this.filter,
          }
        }
      ).toPromise();
      this.data = result;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      if (e instanceof HttpErrorResponse) {
        this.error = `Error: ${e.error?.message ?? Strings.unknownError}`;
      } else if (e instanceof Error) {
        this.error = e.message;
      } else {
        this.error = Strings.unknownError;
      }
    }
  }
}
